import Backbone from './backbone';

export const events = Backbone.Events;
